// import { useSelector } from "react-redux";
import CoverSection from "../PdfReportItems/CoverSection";
import InfoSection from "../PdfReportItems/InfoSection";
import PdfPage from "./PdfPage";
import { useEffect } from "react";

const WholePdfFile = ({ StartDownloadPdf, scheme, appData, demography, type, qrURL }) => {
  //TODO: get this from backend, not redux.
  // let scheme = useSelector((state) => state.reportScheme.inventory.reportScheme);

  useEffect(() => {
    StartDownloadPdf();
  }, []);

  return (
    <div>
      <link
        href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap"
        rel="stylesheet"
      />
      {appData.pdfCoverImageName && (
        <CoverSection
          imageName={appData.pdfCoverImageName}
          appName={appData.name}
          demography={demography}
          qrURL={qrURL}
        />
      )}
      {appData.pdfInfoImageName && <InfoSection imageName={appData.pdfInfoImageName} />}
      {scheme.map((page, index) => {
        return (
          <PdfPage key={index} pageNumber={index + 1} appName={appData.name} personName={demography.name} type={type}>
            {page}
          </PdfPage>
        );
      })}
    </div>
  );
};

export default WholePdfFile;
